import type { SVGProps } from "react";

const SvgBcLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 542 244"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      d="M260 35.2v129.6c0 3.974-1.92 7.2-4.286 7.2H69.286C66.92 172 65 168.774 65 164.8V35.2c0-3.974 1.92-7.2 4.286-7.2h186.428c2.366 0 4.286 3.226 4.286 7.2"
      style={{
        fill: "#e4eceb",
      }}
      transform="matrix(2.72615 0 0 1.62264 -172.2 -40.434)"
    />
    <path
      d="M43.152 25.281c.029-.423.048-.849.048-1.279s-.019-.858-.048-1.281h-9.431l9.114-2.44q-.252-1.268-.662-2.473l-9.114 2.442 8.171-4.719a19 19 0 0 0-1.279-2.216l-8.175 4.718 6.668-6.669a19 19 0 0 0-1.808-1.808l-6.667 6.668 4.72-8.173a19 19 0 0 0-2.218-1.279l-4.719 8.171 2.442-9.114a19 19 0 0 0-2.471-.662l-2.442 9.118V4.848q-.639-.045-1.279-.048c-.43 0-.858.019-1.281.048v12.874a6.4 6.4 0 0 1 1.248-.123c3.513 0 6.403 2.89 6.403 6.403 0 3.5-2.87 6.385-6.37 6.403h-.011c-3.513 0-6.403-2.89-6.403-6.403a6.42 6.42 0 0 1 4.384-6.077L15.529 6.768q-1.153.568-2.218 1.279l4.72 8.177-6.668-6.67a19 19 0 0 0-1.809 1.809l6.668 6.668-8.173-4.72a19 19 0 0 0-1.279 2.218l8.171 4.719-9.114-2.442a19 19 0 0 0-.662 2.471l9.114 2.442H4.848c-.029.423-.048.849-.048 1.279s.019.858.048 1.281h9.431l-9.114 2.444q.252 1.268.662 2.471l9.114-2.442-8.171 4.719q.568 1.153 1.279 2.218l8.173-4.72-6.668 6.668a19 19 0 0 0 1.809 1.809l6.668-6.668-4.72 8.173q1.063.714 2.218 1.279l4.719-8.171-2.442 9.114c.803.272 1.626.497 2.471.662l2.442-9.114v9.431c.423.029.849.048 1.279.048s.858-.019 1.281-.048v-9.431l2.44 9.114c.845-.165 1.67-.39 2.473-.662l-2.442-9.114 4.719 8.171q1.154-.568 2.216-1.279l-4.718-8.173 6.669 6.668a19 19 0 0 0 1.808-1.809l-6.668-6.668 8.172 4.72a19 19 0 0 0 1.28-2.218l-8.171-4.719 9.114 2.442c.273-.803.497-1.626.662-2.471l-9.116-2.442h9.437z"
      style={{
        fillRule: "nonzero",
      }}
      transform="translate(167.96 18.99)scale(4.285)"
    />
  </svg>
);
export default SvgBcLogo;
